import TemplateView from '../../../../../TemplateView'
import PriceListItem from './PriceListItem'

export default class PriceList extends TemplateView {
    constructor() {
        super()

        this.state = {
            prices: [],
        }

        this.onStatePropertyChanged('prices', () => this._updateList())
    }

    templateHtml() {
        return '<div class="priceList"/>'
    }

    _updateList() {
        this.getEl().empty()
        this.state.prices.forEach(price =>
            new PriceListItem({
                description: price.description,
                amount: price.amount,
                additionalClass: price.type,
            }).init(this.getEl())
        )
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/licenses/components/purchaseLightBox/orderSummary/PriceList.js